/** US and Canadian NANP phone number pattern (10-digit local format). */
const nanpPhonePattern = /^(\([2-9]\d{2}\)|[2-9]\d{2})[- .]?\d{3}[- .]?\d{4}$/;

export { nanpPhonePattern };
